import {
  Action,
  ActionType,
  DraftData,
  GameType,
  Hero,
  Player,
  ShopCard,
  StagePack,
  Team,
} from "../types";

import {
  FilterHeroList,
  GetHeroesBasedOnTier,
  GetPlayerDraft,
  GetRandomHero,
  GetRandomHeroForPlayer,
  getRandomInt,
} from "./drafter";
import { DraftStage, IsCompetetiveStage, StageDraftTypes } from "./stageUtils";
import { GetExclucsionList } from "./playerUtils";

import { getHeroData } from "../heroes/useHeroes";
import { DrawCards, LoadTeamsCards } from "./roundHandler";

export function RandomHero(roundData: DraftData): DraftData {
  if (roundData.SelectedPlayers!.length !== 1) {
    console.error("Something wrong with RandomHero card event");
    return roundData;
  }
  if (!roundData.SelectedPlayers![0]) throw new Error();

  const selectedPlayer = roundData.SelectedPlayers![0];

  if (!selectedPlayer.PickedHero) {
    roundData.ActionSequence = removePickActionFromTeam(
      roundData.ActionSequence!,
      selectedPlayer.Team,
    );
  }

  selectedPlayer.PickedHero = GetRandomHeroForPlayer(
    roundData.GameType,
    selectedPlayer,
  );

  return roundData;
}

export function ReRoll(roundData: DraftData): DraftData {
  if (roundData.SelectedPlayers!.length !== 1) {
    console.error("Something wrong with RandomHero card event");
    return roundData;
  }

  const selectedPlayer = roundData.SelectedPlayers![0];

  const heroList = FilterHeroList(
    getHeroData(roundData.GameType),
    GetExclucsionList(selectedPlayer),
  );

  selectedPlayer.Draft = GetPlayerDraft(
    selectedPlayer.Draft!.length ? selectedPlayer.Draft!.length : 3,
    heroList,
  );

  return roundData;
}

export function AndAnotherOne(roundData: DraftData): DraftData {
  roundData.Players!.forEach((player) => {
    const heroList = FilterHeroList(
      getHeroData(roundData.GameType),
      GetExclucsionList(player),
    );
    player.Draft!.push(GetRandomHero(heroList));
  });
  return roundData;
}

export function Trade(roundData: DraftData): DraftData {
  if (roundData.SelectedPlayers!.length !== 1) {
    console.error("Something wrong with Trade card event");
    return roundData;
  }
  const selectedPlayer = roundData.SelectedPlayers![0];
  if (!selectedPlayer || !roundData.Players) throw new Error();

  if (selectedPlayer.Number === 1 || selectedPlayer.Number === 3) {
    tradeDrafts(roundData.Players[0], roundData.Players[2]);
  }

  if (selectedPlayer.Number === 2 || selectedPlayer.Number === 4) {
    tradeDrafts(roundData.Players[1], roundData.Players[3]);
  }

  return roundData;
}

export function DuelTrade(roundData: DraftData): DraftData {
  if (roundData.Players.length !== 2) {
    console.error("Something wrong with DuelTrade card event");
    return roundData;
  }

  tradeDrafts(roundData.Players[0], roundData.Players[1]);
  return roundData;
}

export function Surrekamp(roundData: DraftData, stagePack: StagePack): DraftData {
  roundData.Stage = DraftStage(StageDraftTypes.MEME, roundData.GameType, stagePack);

  let tiers = [6, 7, 8]; // 6=C-, 7=D, 8=F
  if (roundData.GameType === GameType.Ultimate) {
    tiers = [5, 6, 7, 8];
  }

  let surreHeroes = GetHeroesBasedOnTier(
    getHeroData(roundData.GameType),
    tiers,
  );

  roundData.Players!.forEach((p) => {
    p.BannedHeroes = [];
    p.PickedHero = GetRandomHero(surreHeroes);
  });

  roundData.ActionSequence = [];

  return roundData;
}

export function Doppelganger(gameData: DraftData, ownerTeam: Team): DraftData {
  if (gameData.SelectedPlayers!.length !== 1) {
    console.error("Something wrong with Doppelganger card event");
    return gameData;
  }

  const selectedPlayer = gameData.SelectedPlayers![0];

  if (selectedPlayer.Team === ownerTeam) {
    gameData.ActionSequence = removePickActionFromTeam(
      gameData.ActionSequence!,
      ownerTeam,
    );
    selectedPlayer.PickedHero = getDoppelgangerHero();
  } else {
    const doppelgangerSwap: Action = {
      Action: ActionType.CardEffect,
      Team: ownerTeam,
      CardEffect: "doppelgangerSwap",
      Target: selectedPlayer,
    };
    gameData.ActionSequence = [
      doppelgangerSwap,
      ...gameData.ActionSequence!,
    ];
  }

  return gameData;
}

export function DoppelgangerSwap(gameData: DraftData): DraftData {
  const doppelGanger = getDoppelgangerPlayer(gameData);
  const targetNumber = gameData.CurrentAction!.Target!.Number;
  if (!doppelGanger || !targetNumber) {
    console.error("Something went wrong with the doppelgang");
    return gameData;
  }

  const newHeroForDoppelganger =
    gameData.Players!.find((p) => p.Number === targetNumber)!.PickedHero;

  doppelGanger.PickedHero = newHeroForDoppelganger;

  return gameData;
}

const SECRET_SANTA_CARD: string = "Loot Box"
const DOPPELGANGER_CARD: string = "Doppelganger"
export function SecretSanta(gameData: DraftData, shopCardIndex: number): DraftData {
  const allCards = LoadTeamsCards()

  const doppelgangerExists = gameData.ShopCards.some(card => card.Name === DOPPELGANGER_CARD)

  const cardsWithoutSecretSanta: ShopCard[] = []
  allCards.forEach(card => {
    if (card.Name === SECRET_SANTA_CARD) {
      return
    }
    if (doppelgangerExists && card.Name === DOPPELGANGER_CARD) {
      return
    }
    cardsWithoutSecretSanta.push(card)
  })

  const drawnCardList = DrawCards(1, cardsWithoutSecretSanta);
  if (drawnCardList.length !== 1) {
    console.log("Oh ho-ho no, Santa's secret failed!")
    return gameData
  }
  const newCard = drawnCardList[0]
  newCard.Cost = "Free"

  const indexOfPurchasedCard = gameData.ShopCards.findIndex(card => card.Index === shopCardIndex)
  gameData.ShopCards[indexOfPurchasedCard] = newCard

  return gameData
}

export function BanFiesta(gameData: DraftData): DraftData {
  gameData.Players!.forEach((player) => {
    let eligibleBans: string[] = [];
    player.Draft!.forEach((h) => {
      if (!player.BannedHeroes!.includes(h.Name)) {
        eligibleBans.push(h.Name);
      }
    });
    if (eligibleBans.length === 0) return;

    const rng = getRandomInt(eligibleBans.length);

    player.BannedHeroes!.push(eligibleBans[rng]);
  });

  return gameData;
}

export function StageWarp(draftData: DraftData, stagePack: StagePack): DraftData {
  if (!draftData.Stage) throw new Error("Stage warp failed - no stage present");

  if (IsCompetetiveStage(draftData.Stage, draftData.GameType, stagePack)) {
    draftData.Stage = DraftStage(StageDraftTypes.MEME, draftData.GameType, stagePack);
  } else {
    draftData.Stage = DraftStage(StageDraftTypes.STANDARD, draftData.GameType, stagePack);
  }
  return draftData;
}

export function Cuckio(
  roundData: DraftData,
  pickedEnemy: Player,
  pickedHero: Hero,
): DraftData {
  pickedEnemy.Draft?.forEach((hero) => {
    if (hero.Name !== pickedHero.Name) {
      hero.Banned = true;
      pickedEnemy.BannedHeroes?.push(hero.Name);
    }
  });
  roundData.Players.find((p) => p.Number === pickedEnemy.Number)!.Draft =
    pickedEnemy.Draft;
  return roundData;
}

export function BanFiestaFFA(draftData: DraftData): DraftData {
  if (!draftData.CommonHeroes) {
    throw new Error("FFA is missing common heroes list");
  }

  draftData.CommonHeroes = banRandomHeroFromList(draftData.CommonHeroes);
  draftData.CommonHeroes = banRandomHeroFromList(draftData.CommonHeroes);

  return draftData;
}

export function SneakFFA(draftData: DraftData): DraftData {
  const movingPlayer = draftData.CurrentAction?.PlayerNumber;

  // Player List
  const player = draftData.Players.find((p) => p.Number === movingPlayer);
  if (!player) throw new Error("player could not be found");
  let index = draftData.Players.indexOf(player);
  if (index === 0) return draftData;

  draftData.Players[index] =
    draftData.Players.splice(index - 1, 1, draftData.Players[index])[0];

  // Action Sequence
  const pickAction = draftData.ActionSequence?.find((a) =>
    a.PlayerNumber === movingPlayer
  );

  if (!pickAction) throw new Error("Can't find pick action");
  if (!draftData.ActionSequence) throw new Error("No picking sequence");
  index = draftData.ActionSequence.indexOf(pickAction);

  draftData.ActionSequence[index] = draftData.ActionSequence.splice(
    index + 1,
    1,
    draftData.ActionSequence[index],
  )[0];

  return draftData;
}

export function AnotherOneFFA(draft: DraftData): DraftData {
  const heroList = getHeroData(draft.GameType);
  const newRow = GetPlayerDraft(2, heroList);
  draft.CommonHeroes?.push(newRow);
  return draft;
}

function banRandomHeroFromList(commonHeroes: Hero[][]): Hero[][] {
  const rngList = getRandomInt(commonHeroes.length);
  const rngHero = getRandomInt(commonHeroes[rngList].length);

  if (commonHeroes[rngList][rngHero].Banned) {
    return banRandomHeroFromList(commonHeroes);
  }

  commonHeroes[rngList][rngHero].Banned = true;
  return commonHeroes;
}

function tradeDrafts(PlayerA: Player, PlayerB: Player) {
  const tempDraft = PlayerA.Draft;
  const tempBanns = PlayerA.BannedHeroes;

  PlayerA.Draft = PlayerB.Draft;
  PlayerA.BannedHeroes = PlayerB.BannedHeroes;

  PlayerB.Draft = tempDraft;
  PlayerB.BannedHeroes = tempBanns;
}

function removePickActionFromTeam(actionSequence: Action[], team: Team) {
  for (let i = actionSequence.length - 1; i > -1; i--) {
    if (
      actionSequence[i].Action === ActionType.Pick &&
      actionSequence[i].Team === team
    ) {
      actionSequence.splice(i, 1);
      return actionSequence;
    }
  }
  throw new Error("Can't remove pick action from team - something is wrong");
}

//Doppelganger help functions

export function getDoppelgangerTargetName(gameData?: DraftData): string {
  if (!gameData || !gameData.ActionSequence) return "";
  const target = gameData.ActionSequence!.find((a) =>
    a.CardEffect === "doppelgangerSwap"
  );

  if (!target) return "";

  return target.Target!.Name ? target.Target!.Name : "";
}

function getDoppelgangerPlayer(gameData: DraftData) {
  return gameData.Players!.find((p) => {
    if (p.PickedHero) {
      return p.PickedHero.Name.includes("Doppelganger");
    }
    return false;
  });
}

export function getDoppelgangerHero(): Hero {
  return {
    Name: "Doppelganger",
    Tier: -1,
    Image: "doppelganger.png",
  };
}
